(function ($, Cobalt, undefined) {
    Cobalt.ViewStateManager = {
        separator: ";",
        subSeparator: ":",
        trackers: [],
        createBrowserHistory: false,
        initialize: function () {

            if (self.location.hash == "") {
                return;
            }
            var currentHashes = self.location.hash.substring(1).split(Cobalt.ViewStateManager.separator);
            for (var i = 0; i < currentHashes.length; i++) {
                var value = currentHashes[i];
                var id = null;
                if (value.indexOf(Cobalt.ViewStateManager.subSeparator) > 0) {
                    id = value.split(Cobalt.ViewStateManager.subSeparator)[0];
                    value = value.split(Cobalt.ViewStateManager.subSeparator)[1];
                }
                new Cobalt.ViewState(i, id, value);
            }
        },
        updateFromHash: function () {

            var currentHashes = self.location.hash.substring(1).split(Cobalt.ViewStateManager.separator);

            // If the hash is empty, reset each tracker to its default value.
            if (currentHashes[0] == "") {
                var trackers = Cobalt.ViewStateManager.trackers;
                for (var i = 0; i < trackers.length; i++) {
                    trackers[i].value = trackers[i].defaultValue;
                }
            }

            // Otherwise, try to update them
            for (var i = 0; i < currentHashes.length; i++) {
                var value = currentHashes[i];
                var id = null;
                if (value.indexOf(Cobalt.ViewStateManager.subSeparator) > 0) {
                    id = value.split(Cobalt.ViewStateManager.subSeparator)[0];
                    value = value.split(Cobalt.ViewStateManager.subSeparator)[1];
                    var viewState = Cobalt.ViewStateManager.getById(id);
                    if (viewState.value != value) {
                        viewState.setValue(value);
                    }
                }
            }
        },
        getById: function (id) {
            var trackers = Cobalt.ViewStateManager.trackers;
            for (var i = 0; i < trackers.length; i++) {
                if (trackers[i].id == id) {
                    return trackers[i];
                }
            }
            return null;
        },
        removeById: function (id) {
            var trackers = Cobalt.ViewStateManager.trackers;
            var trackerToRemoveIndex = -1;
            for (var i = 0; i < trackers.length; i++) {
                if (trackers[i].id == id) {
                    trackerToRemoveIndex = i;
                }
            }
            if (trackerToRemoveIndex > -1) {
                trackers.splice(trackerToRemoveIndex, 1);
            }
            Cobalt.ViewStateManager.trackers = trackers;
            Cobalt.ViewStateManager.update();
        },
        getViewState: function (id, defaultValue) {
            var trackers = Cobalt.ViewStateManager.trackers;
            var viewState = null;

            if (id != null) {
                viewState = Cobalt.ViewStateManager.getById(id);
                if (viewState != null) {
                    return viewState;
                }

            }

            var index = trackers.length;

            if (trackers[index] != null) {
                return trackers[index];
            }
            else {
                return new Cobalt.ViewState(index + 1, id, defaultValue);
            }
        },
        update: function () {

            var states = [];
            for (var i = 0; i < Cobalt.ViewStateManager.trackers.length; i++) {
                var id = Cobalt.ViewStateManager.trackers[i].id;
                var value = Cobalt.ViewStateManager.trackers[i].value;
                if (value == undefined) {
                    continue;
                }
                if (id != null) {
                    states.push(id + Cobalt.ViewStateManager.subSeparator + value);
                }
                else {
                    states.push(value);
                }

            }

            if (states.length > 0) {
                var newHash = ("#" + states.join(Cobalt.ViewStateManager.separator)).trim();
                while (newHash.endsWith(Cobalt.ViewStateManager.separator)) {
                    newHash = newHash.substring(0, newHash.length - 1);
                }
                var currentLocation = self.location.href;
                if (currentLocation.indexOf("#") >= 0) {
                    currentLocation = currentLocation.substring(0, currentLocation.indexOf("#"));
                }                

                if (Cobalt.ViewStateManager.createBrowserHistory) {
                    self.location.hash = newHash;
                }
                else {
                    self.location.replace(currentLocation + newHash);
                }
            }
            else {
                self.location.hash = "";
            }
        }

    };

    Cobalt.ViewState = function (index, id, value) {
        if (id == "") {
            id = null;
        }
        this.index = index;
        this.value = value;
        this.defaultValue = value;
        this.id = id;
        Cobalt.ViewStateManager.trackers.push(this);
        return this;
    };

    Cobalt.ViewState.prototype = {
        setValue: function (value) {
            if (value == undefined) {
                return;
            }
            this.value = value;
            Cobalt.ViewStateManager.update();
        }
    };

    Cobalt.ViewStateManager.initialize();
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ViewState.js